module.exports = __webpack_public_path__ + "img/content-copy.0eae2b03.svg";